import { useCreateCommentOrder } from "Order/Api/Mutation/createOrderCommentMutation";
import { useDeleteOrderCommentMutation } from "Order/Api/Mutation/useDeleteOrderCommentMutation";
import { useUpdateOrderCommentMutation } from "Order/Api/Mutation/useUpdateCommentMutation";
import { useOrderCommentsByOrderIdQuery } from "Order/Api/Query/useOrderCommentsByOrderIdQuery";
import { Comments } from "Shared/Components/Comments/Components";
import type { FC } from "react";

type OrderCommentsProps = {
	id: number;
	title?: string;
};

export const OrderComments: FC<OrderCommentsProps> = ({ id, title }) => {
	const addComment = useCreateCommentOrder(id);
	const updateCommentMutation = useUpdateOrderCommentMutation(id);
	const deleteCommentMutation = useDeleteOrderCommentMutation(id);
	const { data: comments } = useOrderCommentsByOrderIdQuery(id);

	return (
		<Comments
			addComment={addComment}
			updateCommentMutation={updateCommentMutation}
			deleteCommentMutation={deleteCommentMutation}
			comments={comments}
			title={title}
		/>
	);
};
